import DutyAssignmentPage from './DutyAssignmentPage';

export default DutyAssignmentPage;
